import { doc, updateDoc, addDoc, collection, getDoc } from "firebase/firestore";
import { db } from "config/firebase";
import { DateTime } from "luxon";
import { QueryClient } from "@tanstack/react-query";
import { Board } from "@freetech/models/freelo";
interface AddColumnParams {
  boardId: string;
  name: string;
}

export const createList = async (
  params: AddColumnParams,
  queryClient: QueryClient
): Promise<void> => {
  const { boardId, name } = params;


  await queryClient.cancelQueries({
    queryKey: ["board", boardId],
    exact: true
  });


  const previousBoard = queryClient.getQueryData<Board>(["board", boardId]);
  if (!previousBoard) return;


  const tempListId = `temp_${Date.now()}`;
  const newListOrder = [...(previousBoard.listOrder || []), tempListId];


  const optimisticBoard = {
    ...previousBoard,
    listOrder: newListOrder,
    updatedAt: DateTime.now().toISO(),
  };
  queryClient.setQueryData(["board", boardId], optimisticBoard);

  try {

    const boardRef = doc(db, "boards", boardId);
    const boardDoc = await getDoc(boardRef);
    
    if (!boardDoc.exists()) {
      throw new Error("Board not found");
    }

    const currentBoard = boardDoc.data();


    const listsRef = collection(db, "boards", boardId, "lists");
    const newListRef = await addDoc(listsRef, {
      name: name.trim(),
      cardOrder: [],
      createdAt: DateTime.now().toISO(),
      updatedAt: DateTime.now().toISO(),
    });


    const currentListOrder = currentBoard.listOrder || [];
    const finalListOrder = [...currentListOrder, newListRef.id];


    const boardUpdate = {
      listOrder: finalListOrder,
      updatedAt: DateTime.now().toISO(),
    };


    await updateDoc(boardRef, boardUpdate);


    const finalBoard = {
      ...currentBoard,
      listOrder: finalListOrder,
      updatedAt: DateTime.now().toISO(),
    };
    queryClient.setQueryData(["board", boardId], finalBoard);

  } catch (error) {
    console.error('Error in addColumn:', error); // Debug log

    queryClient.setQueryData(["board", boardId], previousBoard);
    throw error;
  }
}; 